import { render } from "./AdministrationMenu.vue?vue&type=template&id=12c814be&scoped=true"
import script from "./AdministrationMenu.vue?vue&type=script&lang=js"
export * from "./AdministrationMenu.vue?vue&type=script&lang=js"

import "./AdministrationMenu.vue?vue&type=style&index=0&id=12c814be&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c814be"]])

export default __exports__